const ALL_CHART_TYPES_OPTION = 'All Chart Types';

export default ALL_CHART_TYPES_OPTION;
